import { useShowMobileLayout } from '../../../../utils/LayoutUtils';
import { PatientsToolbarSort } from './PatientsToolbarSort';
import { useQuery } from '@apollo/client';
import type { SearchAutocompletePatient } from '@orthly/dentin';
import { PracticeScreen, ToolbarSearch } from '@orthly/dentin';
import { graphql } from '@orthly/graphql-inline-react';
import type { ItemSearchResults } from '@orthly/graphql-react';
import { FlossPalette, styled, TOOLBAR_TABLET_DOWN_HEIGHT, ToolbarContainer, useScreenIsMobile } from '@orthly/ui';
import { Text, useScreenIsMd } from '@orthly/ui-primitives';
import React from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

const ToolbarItemContainer = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1.5fr minmax(250px, 1fr)',
    justifyContent: 'space-between',
    borderLeft: `1px solid ${FlossPalette.DARK_TAN}`,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        gridTemplateColumns: '1fr minmax(150px, 1fr)',
    },
}));

const GetPatientsBySearch_Query = graphql(`
    query GetPatientsBySearch($search: String!) {
        searchPracticePatients(search: $search) {
            id
            first_name
            last_name
            gender
            birthday
        }
    }
`);

export function usePatientSearchResults(): ItemSearchResults<SearchAutocompletePatient> {
    const [search, setSearch] = React.useState<string | undefined>();

    const skip = !search || search.length < 2;

    const { data, loading } = useQuery(GetPatientsBySearch_Query, {
        variables: {
            search: search ?? '',
        },
        skip,
    });

    return { search, setSearch, items: data?.searchPracticePatients ?? [], skipQuery: skip, loading };
}

export const PatientsOverviewToolbar: React.FC = () => {
    const isMobile = useScreenIsMobile();
    const isMd = useScreenIsMd();
    const isMobileLayout = useShowMobileLayout();
    const navigate = useNavigate();

    return (
        <ToolbarContainer
            sticky
            style={{
                padding: 0,
                top: isMd && !isMobileLayout ? TOOLBAR_TABLET_DOWN_HEIGHT : 0,
                overflow: 'hidden',
                justifyContent: 'space-between',
            }}
        >
            {!isMobile && (
                <Text variant={'h5'} style={{ padding: '0 40px' }}>
                    Patients
                </Text>
            )}
            <ToolbarItemContainer>
                <ToolbarSearch
                    searchType={'patient'}
                    onPickItem={id => navigate(`/${PracticeScreen.patients}/${id}`)}
                    useSearchResults={usePatientSearchResults}
                />
                <PatientsToolbarSort />
            </ToolbarItemContainer>
        </ToolbarContainer>
    );
};
